<template>
  <div class="max-w-4xl mx-auto px-6 py-10 text-gray-800">
    <h1 class="text-3xl font-bold mb-6 text-center">Mentions Légales</h1>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">1. Éditeur du site</h2>
      <p>
        Le site <strong>BookMySalon</strong> est édité par :
      </p>
      <ul class="list-disc pl-6 mt-2">
        <li>Nom de l’entreprise : <strong>NATUREL & JOLI</strong></li>
        <li>Forme juridique : <strong>SASU</strong> (ou autre à adapter)</li>
        <li>Siège social : <strong>12 rue des Coiffeurs, 75000 Paris, France</strong></li>
        <li>Numéro SIRET : <strong>123 456 789 00010</strong></li>
        <li>Email de contact : <a href="mailto:contact@bookmysalon.fr" class="text-blue-600 underline">contact@bookmysalon.fr</a></li>
        <li>Directeur de la publication : <strong>[Ton prénom et nom]</strong></li>
      </ul>
    </section>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">2. Hébergement</h2>
      <p>
        Le site est hébergé par :
      </p>
      <ul class="list-disc pl-6 mt-2">
        <li>Hébergeur : <strong>Hostinger International Ltd.</strong></li>
        <li>Adresse : 61 Lordou Vironos Street, 6023 Larnaca, Chypre</li>
        <li>Site web : <a href="https://www.hostinger.fr" target="_blank" class="text-blue-600 underline">www.hostinger.fr</a></li>
      </ul>
    </section>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">3. Propriété intellectuelle</h2>
      <p>
        Le contenu du site (textes, images, logo, design, etc.) est protégé par le droit de la propriété intellectuelle.
        Toute reproduction ou représentation, totale ou partielle, sans autorisation préalable écrite est interdite.
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">4. Données personnelles</h2>
      <p>
        Les données personnelles collectées via le site sont traitées conformément à notre
        <RouterLink to="/politique-confidentialite" class="text-blue-600 underline">Politique de Confidentialité</RouterLink>.
        L’utilisateur dispose d’un droit d’accès, de rectification et de suppression de ses données personnelles.
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">5. Responsabilité</h2>
      <p>
        BookMySalon s’efforce de fournir des informations fiables mais ne saurait être tenue responsable d’erreurs, d’omissions ou
        d’éventuels dysfonctionnements liés à l’usage du site.
      </p>
    </section>

    <section class="mb-6">
      <h2 class="text-2xl font-semibold mb-2">6. Loi applicable</h2>
      <p>
        Les présentes mentions légales sont régies par la loi française. En cas de litige, les tribunaux français seront seuls compétents.
      </p>
    </section>

    <footer class="text-sm text-gray-500 text-center mt-10">
      Dernière mise à jour : 24 juin 2025
    </footer>
  </div>
</template>

<script setup>
// Aucun script requis
</script>

<style scoped>
/* Aucun style personnalisé nécessaire avec Tailwind */
</style>
